<template>
  <base-material-card 
    color="primary" 
    icon="mdi-firebase" 
    :title="title" 
    inline 
    class="px-5 py-4 ml-0">
      <v-col cols="12">
        <v-alert 
          dense 
          outlined 
          type="warning" 
          class="mt-5 py-0 px-1"
        >
          <b>Atenção:</b> os registros alterados nessa tela são replicados em todos os sistemas.
        </v-alert>
          <v-alert 
            dense 
            outlined 
            color="blue" 
            type="info" 
            class="pa-1"
          >
              A empresa atualmente está configurada no grupo <b> BPR {{ grupoEmpresa }}</b>. Caso deseje alterar o
                grupo, vá até a página Configurações do Sistema e altere a configuração Agrupamento da empresa no BPR.
          </v-alert>
      </v-col>
        <v-tabs id="grupos-joa" v-model="activeTab" class="mb-5" >
          <v-tab v-for="grupo in grupos" :key="grupo">
            Grupo {{ grupo }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="activeTab" >
          <v-tab-item v-for="item in items" 
            :key="item.grupo"
          >
            <v-data-table 
              :headers="[
                {text: 'Tipologia ANEEL', value: 'TipologiaANEEL'},
                {text: 'JOA(%)', value: 'joa'}
                ]" 
              :items="item.dados" 
              dense 
              disable-pagination 
              hide-default-footer 
              disable-filtering
              disable-sort mobile-breakpoint="760">
                <template v-slot[`item.TipologiaANEEL`]="{ item }">
                  {{ item["TipologiaANELL"]}}
                </template>
                <template v-slot:[`item.joa`]="{ item }">
                  <v-text-field 
                    style="width:100px"
                    v-model="item.joa" 
                    hide-details 
                    class="my-0 py-0" 
                    min="0" type="number" step="0.01">
                  </v-text-field>
                </template>
                </v-data-table>
            </v-tab-item>
        </v-tabs-items>
    </base-material-card>
</template>
<script>
    import JoaService from '@/services/JoaService.js'
    export default {
    name: "JoaEdit",

    computed: {
        title() {
            return this.$route.name;
        },
        items() {
            if(!this.grupos) return [];

            let items = []

            this.grupos.forEach(grupo => {
                items.push({
                    grupo: grupo,
                    dados: this.dadosJoa.filter((dado) => dado.GrupoEmpresaANEEL === grupo)
                })
            });
            return items;
        },
    },

    mounted(){
        this.getJoa();
    },

    data:() => ({
        activeTab: undefined,
        grupos: undefined,
        grupoEmpresa: undefined,
        dadosJoa: undefined,
       
    }),

    methods: {
       getJoa(){
        JoaService.getJoa().then(response => {
            this.grupos = response.data.grupos;
            this.grupoEmpresa = response.data.grupoEmpresa;
            this.dadosJoa = response.data.dadosJoa;
            this.activeTab = (response.data.grupoEmpresa - 1)
        })
        .catch(err => {
            this.$toast.error('Erro ao buscar dados', '', { position:'topRight' });
        })
        .finally(() => {this.loadingItems = false});
       },   
    }
}
</script>